import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3)};
  `,
}
